<app-local-loading-indicator *ngIf="rangeSvc.isLoading$ | async" width="90%" height="100%" applyOverlay="true">
</app-local-loading-indicator>
<app-common-filter [list]="rangeList" textField='Description' [(filter)]="filter" [(isDirty)]="isDirty"
    valueField="SensorRangeId" identifier="shipment_filter_temp">
</app-common-filter>